<mat-card *ngIf="edition && data">
  <mat-card-title fxLayout="row" fxLayoutAlign="center center">
    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span *ngIf="edition.publishDates.length > 1">
      <span>Edición: </span>
      <span> {{edition.publishDates[0] | date: 'dd MMMM \'de\' yyyy'}} </span>
      <span> al </span>
      <span> {{edition.publishDates[edition.publishDates.length -1] | date: 'dd MMMM \'de\' yyyy'}} </span>
    </span>
    <span *ngIf="edition.publishDates.length == 1">
      <span>Edición: </span>
      <span> {{edition.publishDates[0] | date: 'dd MMMM \'de\' yyyy'}} </span>
    </span>
    <div fxFlex></div>
    <button mat-icon-button (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-subtitle *ngIf="data.publishLogging">
    Edición ya publicada el {{data.publishLogging.publishTime | date: 'dd MMMM \'de\' yyyy \'a las\' HH:mm:ss'}}. {{data.publishLogging.total}}
    documentos publicados por {{data.publishLogging.userName}}
  </mat-card-subtitle>
  <mat-card-subtitle *ngIf="!data.publishLogging">
    Esta edición aún no ha sido publicada
  </mat-card-subtitle>
  <mat-card-content *ngIf="!hasProducts" fxLayout="row">
    <div fxFlex></div>
    <div class="mat-card-title">No hay ningún edicto para exportar en esta edición</div>
    <div fxFlex></div>

  </mat-card-content>
  <mat-card-content *ngIf="hasProducts">
    Seleccione la familia de documentos a exportar
    <div fxLayout="row">
      <div fxFlex></div>
      <div fxLayout="column">
        <div class="product" fxLayout="row" fxLayoutAlign="center center">
          <div class="quantity" fxFlex="50">{{totalDocuments}}</div>
          <mat-checkbox fxFlex="50" (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"
            color="primary">
            Seleccionar Todos
          </mat-checkbox>
        </div>
        <div class="product" fxLayout="row" fxLayoutAlign="center center" *ngFor="let item of data.products">
          <div class="quantity" fxFlex="50">{{item.quantity}}</div>
          <mat-checkbox fxFlex="50" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(item) : null; this.updateHref();"
            [checked]="selection.isSelected(item)" color="primary">
            {{item.productDescription}}
          </mat-checkbox>
        </div>
      </div>
      <div fxFlex></div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end" *ngIf="hasProducts">
    <div *ngIf="!data.publishLogging && isAllSelected()">
      <div *ngIf="data.pendingDocumentsCount && !omitInProgressDocuments">
        Aún faltan {{data.pendingDocumentsCount}} por digitar en esta edición puede
        <button (click)="omitInProgressDocuments = true" mat-button>Omitirlos</button>
      </div>
      <a *ngIf="!data.pendingDocumentsCount || omitInProgressDocuments" [href]="definitiveHref" target="_blank" mat-button>Definitivo</a>
    </div>
    <a *ngIf="selection.hasValue()" [href]="draftHref" target="_blank" mat-button>
      <mat-icon>description</mat-icon> Borrador</a>
  </mat-card-actions>
</mat-card>
